var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb10" },
        [
          _c("el-input", {
            staticClass: "bottom-line",
            staticStyle: { width: "320px" },
            attrs: { disabled: true },
            model: {
              value: _vm.merchtTplRole.mobAppRoleName,
              callback: function($$v) {
                _vm.$set(_vm.merchtTplRole, "mobAppRoleName", $$v)
              },
              expression: "merchtTplRole.mobAppRoleName"
            }
          }),
          _vm._v(" "),
          _vm.mobAppRoleCode == null && !_vm.readOnly
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small mt5",
                  on: {
                    click: function($event) {
                      _vm.showMobAppRoleDlg()
                    }
                  }
                },
                [_vm._v("关联移动角色")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mobAppRoleCode != null && !_vm.readOnly
            ? _c(
                "button",
                {
                  staticClass: "swb-btn swb-btn-small mt5",
                  on: {
                    click: function($event) {
                      _vm.clearMobAppRole()
                    }
                  }
                },
                [_vm._v("移除移动角色")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.mobAppRoleCode != null
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.navTopicList, function(navTopicInfo) {
              return _c(
                "el-tab-pane",
                {
                  attrs: { label: navTopicInfo.name, name: navTopicInfo.name }
                },
                [
                  navTopicInfo.itemList != null &&
                  navTopicInfo.itemList.length > 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "group-container" },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.checkedRescIds,
                                  callback: function($$v) {
                                    _vm.checkedRescIds = $$v
                                  },
                                  expression: "checkedRescIds"
                                }
                              },
                              [
                                navTopicInfo.itemList != null &&
                                navTopicInfo.itemList.length > 0
                                  ? _vm._l(navTopicInfo.itemList, function(
                                      itemInfo
                                    ) {
                                      return _c(
                                        "div",
                                        { staticClass: "item-container" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-title" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  on: {
                                                    change: function($event) {
                                                      _vm.handleCheckAllChange(
                                                        itemInfo
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        disabled: _vm.readOnly,
                                                        label: itemInfo.rescId
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            "font-gray2 mr5":
                                                              _vm.ctxVipLevel <
                                                              itemInfo.sysResc
                                                                .forVip
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              itemInfo.dispName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.ctxVipLevel <
                                                      itemInfo.sysResc.forVip
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-red"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "【" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .vipLevel[
                                                                      itemInfo
                                                                        .sysResc
                                                                        .forVip
                                                                    ]
                                                                  ) +
                                                                  "】及以上"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      itemInfo.sysResc.desc !=
                                                      null
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-gray3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "（" +
                                                                  _vm._s(
                                                                    itemInfo
                                                                      .sysResc
                                                                      .desc
                                                                  ) +
                                                                  "）"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          itemInfo.actionList != null &&
                                          itemInfo.actionList.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "item-content"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "switch-list clearfix ml15"
                                                      },
                                                      [
                                                        _c(
                                                          "el-checkbox-group",
                                                          {
                                                            model: {
                                                              value:
                                                                itemInfo.checkedActions,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  itemInfo,
                                                                  "checkedActions",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "itemInfo.checkedActions"
                                                            }
                                                          },
                                                          _vm._l(
                                                            itemInfo.actionList,
                                                            function(action) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "switch-item ellipsis-1",
                                                                  staticStyle: {
                                                                    width:
                                                                      "auto",
                                                                    "margin-right":
                                                                      "30px"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-checkbox",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          _vm.checkedRescIds.indexOf(
                                                                            itemInfo.rescId
                                                                          ) <
                                                                            0 ||
                                                                          _vm.readOnly,
                                                                        label:
                                                                          action.code
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.handleCheckChange(
                                                                            action.code,
                                                                            itemInfo.rescId
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              action.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  navTopicInfo.groupList != null &&
                  navTopicInfo.groupList.length > 0
                    ? _vm._l(navTopicInfo.groupList, function(groupInfo) {
                        return _c(
                          "div",
                          { staticClass: "group-container" },
                          [
                            _c(
                              "div",
                              { staticClass: "content-caption dashed" },
                              [
                                _c("span", { staticClass: "font-gray2 mr5" }, [
                                  _vm._v(_vm._s(groupInfo.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.checkedRescIds,
                                  callback: function($$v) {
                                    _vm.checkedRescIds = $$v
                                  },
                                  expression: "checkedRescIds"
                                }
                              },
                              [
                                groupInfo.itemList != null &&
                                groupInfo.itemList.length > 0
                                  ? _vm._l(groupInfo.itemList, function(
                                      itemInfo
                                    ) {
                                      return _c(
                                        "div",
                                        { staticClass: "item-container" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-title" },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  on: {
                                                    change: function($event) {
                                                      _vm.handleCheckAllChange(
                                                        itemInfo
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      attrs: {
                                                        disabled: _vm.readOnly,
                                                        label: itemInfo.rescId
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          class: {
                                                            "font-gray2 mr5":
                                                              _vm.ctxVipLevel <
                                                              itemInfo.sysResc
                                                                .forVip
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              itemInfo.dispName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm.ctxVipLevel <
                                                      itemInfo.sysResc.forVip
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-red"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "【" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .vipLevel[
                                                                      itemInfo
                                                                        .sysResc
                                                                        .forVip
                                                                    ]
                                                                  ) +
                                                                  "】及以上"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      itemInfo.sysResc.desc !=
                                                      null
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "font-gray3"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "（" +
                                                                  _vm._s(
                                                                    itemInfo
                                                                      .sysResc
                                                                      .desc
                                                                  ) +
                                                                  "）"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          itemInfo.actionList != null &&
                                          itemInfo.actionList.length > 0
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "item-content"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "switch-list clearfix ml15"
                                                      },
                                                      [
                                                        _c(
                                                          "el-checkbox-group",
                                                          {
                                                            model: {
                                                              value:
                                                                itemInfo.checkedActions,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  itemInfo,
                                                                  "checkedActions",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "itemInfo.checkedActions"
                                                            }
                                                          },
                                                          _vm._l(
                                                            itemInfo.actionList,
                                                            function(action) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "switch-item ellipsis-1",
                                                                  staticStyle: {
                                                                    width:
                                                                      "auto",
                                                                    "margin-right":
                                                                      "30px"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-checkbox",
                                                                    {
                                                                      attrs: {
                                                                        disabled:
                                                                          _vm.checkedRescIds.indexOf(
                                                                            itemInfo.rescId
                                                                          ) <
                                                                            0 ||
                                                                          _vm.readOnly,
                                                                        label:
                                                                          action.code
                                                                      },
                                                                      on: {
                                                                        change: function(
                                                                          $event
                                                                        ) {
                                                                          _vm.handleCheckChange(
                                                                            action.code,
                                                                            itemInfo.rescId
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              action.name
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    })
                                  : _vm._e()
                              ],
                              2
                            )
                          ],
                          1
                        )
                      })
                    : _vm._e()
                ],
                2
              )
            })
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bd24744", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd24744","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/MerchtTplRoleRescForMobApp.vue
// module id = 3466
// module chunks = 0